import Navbar from "../components/NavBar";
import HeroLicenciatura from "../components/TopPage";
import "./Registro.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import Footer from "../components/Footer";
import React, { useState } from "react";

export default function Registro() {
  const [miniFormData, setMiniFormData] = useState({
    nombre: "",
    apellidos: "",
    correo: "",
  });

  const handleMiniFormChange = (field, value) => {
    setMiniFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMiniFormWhatsAppSubmit = () => {
    const { nombre, apellidos, correo } = miniFormData;

    if (!nombre.trim() || !apellidos.trim() || !correo.trim()) {
      alert("Por favor completa Nombre(s), Apellidos y Correo Electrónico.");
      return;
    }

    const numeroWhatsApp = "5219651007363";

    const mensaje = `Hola, solicito más información.

Nombre(s): ${nombre}
Apellidos: ${apellidos}
Correo electrónico: ${correo}`;

    const url = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(
      mensaje,
    )}`;

    window.open(url, "_blank");
  };

  return (
    <div className="app-root" style={{ position: "relative" }}>
      <Navbar />

      <main style={{ position: "relative", zIndex: 1 }}>
        <HeroLicenciatura
          title="ESTUDIA CON"
          highlight="NOSOTROS."
          subtitle=""
          cct=""
        />
      </main>

      <section
        className="w-full overflow-hidden"
        style={{
          position: "relative",
          marginTop: "-200px",
        }}
      >
        <div
          className="equipo-wrap"
          style={{
            position: "relative",
            width: "100%",
            height: "clamp(560px, 65vw, 1050px)",
            overflow: "hidden",
          }}
        >
          <img
            className="block equipo-image"
            src={`${process.env.PUBLIC_URL}/images/imagen_fondo.png`}
            alt="Equipo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center 22%",
              display: "block",
            }}
          />

          <div className="hero-card">
            <p style={{ marginBottom: 8 }}>
              Te apasionan las redes sociales, la creación de contenido y las
              estrategias de venta? ¿O buscas herramientas para llevar tu
              negocio al siguiente nivel?
            </p>

            <p style={{ fontWeight: 700, marginBottom: 8 }}>
              ¡Entonces esta carrera es para ti!
            </p>

            <p style={{ marginBottom: 0 }}>
              Estudia la Licenciatura en Marketing Digital en la Universidad de
              Ciencias y Artes de Chiapas y transforma tu creatividad en una
              profesión.
            </p>
          </div>

          <div className="hero-cta">
            ✨ Tu futuro está al alcance de tus manos. ¡Es momento de dar el
            primer paso!
          </div>
        </div>
      </section>

      <section
        className="w-full"
        style={{
          width: "100%",
          background: "#fff",
          position: "relative",
          zIndex: 2,
          padding: "clamp(18px, 3vw, 40px) 0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              alignItems: "center",
              gap: "clamp(16px, 3vw, 40px)",
            }}
          >
            {/* Texto izquierda */}
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: "0.95rem",
                  letterSpacing: "0.08em",
                  fontWeight: 700,
                  color: "#f4a640",
                  marginBottom: 6,
                  textTransform: "uppercase",
                }}
              >
                REGISTRO DE
              </div>

              <h2
                style={{
                  margin: "0 0 14px 0",
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.05,
                  fontWeight: 800,
                  color: "#0f3b63",
                }}
              >
                ASPIRANTES<span style={{ color: "#0f3b63" }}>.</span>
              </h2>

              <p
                style={{
                  margin: "0 0 10px 0",
                  color: "#6b7786",
                  lineHeight: 1.55,
                  fontSize: "1.02rem",
                }}
              >
                🎉 ¡No esperes más para empezar tu futuro!
              </p>

              <p
                style={{
                  margin: "0 0 10px 0",
                  color: "#6b7786",
                  lineHeight: 1.55,
                  fontSize: "1.02rem",
                }}
              >
                ¿Listo para estudiar Marketing Digital y convertirte en un
                experto en redes, contenido y estrategias que venden?
              </p>

              <p
                style={{
                  margin: "12px 0 6px 0",
                  fontWeight: 800,
                  color: "#5b6775",
                  lineHeight: 1.4,
                }}
              >
                📣 ¡Tenemos una gran noticia!
              </p>

              <p
                style={{
                  margin: "0 0 10px 0",
                  color: "#6b7786",
                  lineHeight: 1.55,
                  fontSize: "1.02rem",
                }}
              >
                El preregistro está abierto todo el año, así que no importa en
                qué momento decidas dar el paso,{" "}
                <strong>¡la puerta siempre está abierta para ti!</strong>
              </p>

              <p
                style={{
                  margin: "14px 0 0 0",
                  color: "#0f3b63",
                  fontWeight: 800,
                  lineHeight: 1.4,
                }}
              >
                En la Universidad Autónoma de Ciencias y Artes de Chiapas
                creemos en los sueños no tienen fecha de caducidad.
              </p>
            </div>

            {/* Imagen derecha (tu imagen completa ya con formas) */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/Estudiante.png`}
                alt="Registro de aspirantes"
                style={{
                  width: "100%",
                  maxWidth: 560,
                  height: "auto",
                  display: "block",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          padding: "clamp(26px, 3.6vw, 54px) 0",
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/fondo_info.png)`, // <-- cambia esta imagen
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay azul */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "#0f3b63",
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          <div style={{ maxWidth: 760 }}>
            <div
              style={{
                fontSize: "clamp(0.95rem, 1.2vw, 1.05rem)",
                fontWeight: 700,
                letterSpacing: "0.04em",
                color: "#f4a640",
                marginBottom: 4,
                textTransform: "uppercase",
              }}
            >
              SOLICITA MÁS
            </div>

            <h2
              style={{
                margin: "0 0 12px 0",
                fontSize: "clamp(2.1rem, 4.2vw, 3.1rem)",
                lineHeight: 1.05,
                fontWeight: 900,
                color: "#ffffff",
                textTransform: "uppercase",
              }}
            >
              INFORMACIÓN
            </h2>

            <p
              style={{
                margin: "0 0 10px 0",
                color: "rgba(255,255,255,0.92)",
                lineHeight: 1.6,
                fontSize: "clamp(1rem, 1.25vw, 1.1rem)",
              }}
            >
              ✍️ Solo llena este formulario y comienza tu camino hacia una
              carrera con futuro, creatividad y muchas oportunidades.
            </p>

            <p
              style={{
                margin: "0 0 10px 0",
                color: "rgba(255,255,255,0.92)",
                lineHeight: 1.6,
                fontSize: "clamp(1rem, 1.25vw, 1.1rem)",
                fontWeight: 700,
              }}
            >
              Te enviaremos toda la información que necesitas para dar el primer
              paso.
            </p>

            <p
              style={{
                margin: 0,
                color: "rgba(255,255,255,0.9)",
                lineHeight: 1.6,
                fontSize: "clamp(1rem, 1.25vw, 1.1rem)",
              }}
            >
              Tu momento es ahora.{" "}
              <span style={{ color: "#f4a640", fontWeight: 800 }}>
                ¡Inscríbete cuando quieras y empieza a transformar tu vida con
                Marketing Digital!!
              </span>
            </p>
          </div>
        </div>
      </section>

      <section
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/fondo_formulario_contacto.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "clamp(24px, 3.5vw, 42px) 0 0",
        }}
      >
        {/* Overlay suave para “lavar” la imagen */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.70)",
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
          }}
        >
          {/* Encabezado */}
          <div style={{ marginBottom: 14 }}>
            <div
              style={{
                fontSize: "0.95rem",
                letterSpacing: "0.06em",
                fontWeight: 700,
                color: "#f4a640",
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              FORMULARIO
            </div>

            <h2
              style={{
                margin: 0,
                fontSize: "clamp(2rem, 3.4vw, 2.8rem)",
                fontWeight: 900,
                color: "#0f3b63",
                textTransform: "uppercase",
                lineHeight: 1.05,
              }}
            >
              DE CONTACTO
            </h2>
          </div>

          {/* Layout principal: Card del formulario */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "clamp(16px, 3vw, 30px)",
              alignItems: "start",
            }}
          >
            {/* Caja/Form */}
            <div
              style={{
                width: "100%",
                background: "rgba(255,255,255,0.88)",
                border: "2px solid rgba(244,166,64,0.55)",
                borderRadius: 8,
                padding: "clamp(16px, 2.2vw, 26px)",
                boxShadow: "0 14px 40px rgba(0,0,0,0.10)",
                backdropFilter: "blur(3px)",
              }}
            >
              <h3
                style={{
                  margin: "0 0 16px 0",
                  color: "#0f3b63",
                  fontSize: "clamp(1.15rem, 1.6vw, 1.35rem)",
                  fontWeight: 900,
                  lineHeight: 1.15,
                }}
              >
                ¡Tu futuro empieza hoy con la <br />
                Universidad Autónoma de Ciencias y Artes de Chiapas!
              </h3>

              {/* ===== PrimeReact Form ===== */}
              {/* Requiere: InputText, Button (y opcional: classnames de PrimeFlex) */}

              <div style={{ display: "grid", gap: 14 }}>
                {/* Nombre(s) */}
                <div>
                  <label
                    htmlFor="nombre"
                    style={{
                      display: "block",
                      fontWeight: 700,
                      color: "#0f3b63",
                      marginBottom: 6,
                    }}
                  >
                    Nombre (s) <span style={{ color: "#d32f2f" }}>*</span>
                  </label>

                  {/* PrimeReact InputText */}
                  <InputText
                    id="nombre"
                    value={miniFormData.nombre}
                    onChange={(e) =>
                      handleMiniFormChange("nombre", e.target.value)
                    }
                    placeholder="Nombre (s)"
                    style={{
                      width: "100%",
                      borderRadius: 999,
                      padding: "0.85rem 1rem",
                      background: "rgba(0,0,0,0.10)",
                      border: "1px solid rgba(0,0,0,0.08)",
                    }}
                  />
                </div>

                {/* Apellidos */}
                <div>
                  <label
                    htmlFor="apellidos"
                    style={{
                      display: "block",
                      fontWeight: 700,
                      color: "#0f3b63",
                      marginBottom: 6,
                    }}
                  >
                    Apellidos <span style={{ color: "#d32f2f" }}>*</span>
                  </label>

                  <InputText
                    id="apellidos"
                    value={miniFormData.apellidos}
                    onChange={(e) =>
                      handleMiniFormChange("apellidos", e.target.value)
                    }
                    placeholder="Apellidos"
                    style={{
                      width: "100%",
                      borderRadius: 999,
                      padding: "0.85rem 1rem",
                      background: "rgba(0,0,0,0.10)",
                      border: "1px solid rgba(0,0,0,0.08)",
                    }}
                  />
                </div>

                {/* Correo */}
                <div>
                  <label
                    htmlFor="correo"
                    style={{
                      display: "block",
                      fontWeight: 700,
                      color: "#0f3b63",
                      marginBottom: 6,
                    }}
                  >
                    Correo Electrónico{" "}
                    <span style={{ color: "#d32f2f" }}>*</span>
                  </label>

                  <InputText
                    id="correo"
                    type="email"
                    value={miniFormData.correo}
                    onChange={(e) =>
                      handleMiniFormChange("correo", e.target.value)
                    }
                    placeholder="Correo Electrónico"
                    style={{
                      width: "100%",
                      borderRadius: 999,
                      padding: "0.85rem 1rem",
                      background: "rgba(0,0,0,0.10)",
                      border: "1px solid rgba(0,0,0,0.08)",
                    }}
                  />
                </div>

                {/* Botón WhatsApp */}
                <div style={{ marginTop: 6 }}>
                  <Button
                    type="button"
                    label="Enviar por Whatsapp"
                    icon="pi pi-whatsapp"
                    style={{
                      width: "fit-content",
                      borderRadius: 999,
                      padding: "0.85rem 1.25rem",
                      fontWeight: 800,
                      background: "#25D366",
                      border: "none",
                      boxShadow: "0 10px 20px rgba(37,211,102,0.25)",
                    }}
                    onClick={handleMiniFormWhatsAppSubmit}
                  />
                </div>

                <p
                  style={{
                    margin: "6px 0 0 0",
                    color: "#0f3b63",
                    opacity: 0.85,
                    fontWeight: 700,
                  }}
                >
                  Pronto nos pondremos en contacto contigo.
                </p>
              </div>
            </div>

            {/* Columna derecha (vacía a propósito) 
          La imagen de fondo ya trae el personaje; aquí solo mantenemos el espacio en pantallas grandes */}
            <div style={{ minHeight: 1 }} />
          </div>
        </div>

        {/* Franja inferior naranja con logo */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            marginTop: "clamp(18px, 3vw, 28px)",
            background: "#f4a640",
            padding: "clamp(18px, 2.6vw, 28px) 0",
          }}
        >
          <div
            style={{
              maxWidth: 1200,
              margin: "0 auto",
              padding: "0 clamp(14px, 3vw, 24px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/Top.png`} // <-- cambia el logo
              alt="Marketing Digital UNICACH"
              style={{
                width: "min(360px, 78vw)",
                height: "auto",
                display: "block",
              }}
            />
          </div>
        </div>
      </section>

      <section
        className="w-full"
        style={{ background: "#fff", padding: "2.5rem 1rem" }}
      >
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div
            style={{
              color: "#F2933F",
              fontWeight: 800,
              letterSpacing: ".5px",
              marginBottom: 6,
            }}
          >
            NUESTRAS
          </div>
          <h2
            style={{
              color: "#0f3b63",
              fontWeight: 900,
              marginTop: 0,
              marginBottom: 24,
            }}
          >
            REDES SOCIALES
          </h2>

          <div className="grid">
            {/* Facebook */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-facebook"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Facebook
                </div>
              </a>
            </div>

            {/* Instagram */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-instagram"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Instagram
                </div>
              </a>
            </div>

            {/* YouTube */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-youtube"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Youtube
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
